export const CardViewEnum = {
  COMPACT: 'compact',
  NORMAL: 'normal',
  EXPANDED: 'expanded',
} as const;
export type CardViewEnum = (typeof CardViewEnum)[keyof typeof CardViewEnum];
